import React from "react";
import { NavLink } from "react-router-dom";

import logo from "../assets/logo.png";
import { useAuth } from "../context/AuthContext";
import { colors } from "../theme/colors";

const NAV_ITEMS = [
  { to: "/", label: "Hoje" },
  { to: "/dashboard", label: "Dashboard" },
  { to: "/pipeline", label: "Pipeline" },
  { to: "/oportunidades", label: "Oportunidades" },
  { to: "/followups", label: "Follow-ups" },
  { to: "/analiticos", label: "Analíticos" },
  { to: "/configuracoes", label: "Configurações" },
];

const C = colors;

export function Sidebar() {
  const { username, logout } = useAuth();

  return (
    <aside
      className="flex h-screen w-[220px] flex-col"
      style={{
        background: `linear-gradient(180deg, ${C.plumDeep} 0%, ${C.plumNight} 55%, ${C.plum} 140%)`,
      }}
    >
      <div className="px-5 py-6">
        <img
          src={logo}
          alt="MINEHR"
          className="h-7 w-auto"
          style={{ filter: "brightness(0) invert(1)" }}
        />
        <p className="mt-2 text-[11px] font-medium uppercase tracking-[0.18em]" style={{ color: C.accent }}>
          Sales Cockpit
        </p>
      </div>

      <nav className="flex-1 space-y-1 px-3">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className="block rounded-xl px-3 py-2 text-sm font-medium transition-colors"
            style={({ isActive }) =>
              isActive
                ? { background: "rgba(96,187,155,0.16)", color: "#FFFFFF", boxShadow: `inset 3px 0 0 ${C.accent}` }
                : { color: C.lilacSoft }
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="px-5 py-4" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <p className="truncate text-sm" style={{ color: "#F4EFF4" }}>{username}</p>
        <button
          type="button"
          onClick={logout}
          className="mt-1.5 text-sm font-medium hover:underline"
          style={{ color: C.accent }}
        >
          Sair
        </button>
      </div>
    </aside>
  );
}
